const projectMetadata = {
  ASAPH: {
    platform: 'iOS · Android',
    role: 'Front-End Developer',
    statusKey: 'live',
    descriptionTh: 'แอป Live Shopping & Marketplace — ซื้อ ขาย และ Go Live',
  },
  'Pikul Wallet (Release and developing)': {
    platform: 'iOS · Android',
    role: 'Front-End Developer',
    statusKey: 'live',
    descriptionTh: 'แอป E-Wallet สำหรับ Asset World Corporation (โปรเจกต์ปัจจุบัน)',
  },
  'DLT Taxi Driver': {
    platform: 'iOS · Android',
    role: 'Front-End Developer',
    statusKey: 'live',
    descriptionTh: 'แอปลงทะเบียนผู้ขับแท็กซี่ กรมการขนส่งทางบก — ใช้งานจริงทั่วประเทศ',
  },
  'SCB Business Anywhere': {
    platform: 'iOS · Android',
    role: 'Front-End Developer',
    statusKey: 'live',
    descriptionTh: 'แอปธนาคาร SCB สำหรับลูกค้าองค์กร — จัดการบัญชีและธุรกรรม 24/7',
  },
};

export default projectMetadata;
